import { combineReducers } from "redux";

import artistName from "./reducers/artistName";
import trackName from "./reducers/trackName";
import trackDetails from "./reducers/trackDetails";
import trackBlob from "./reducers/trackBlob";
import selectedScraper from "./reducers/selectedScraper";
import artistTracks from "./reducers/artistTracks";
import artistDetails from "./reducers/artistDetails";
import artistSearch from "./reducers/artistSearch";
import searchFilters from "./reducers/searchFilters";
import maxResults from "./reducers/maxResults";
import error from "./reducers/error";

const rootReducer = combineReducers({
    trackDetails,
    trackBlob,
    artistTracks,
    artistDetails,
    artistSearch,
    searchFilters,
    maxResults,
    selectedScraper,
    artistName,
    trackName,
    error
});

export default rootReducer;
